
import { Fragment } from "react";

import SpecialistSearchBanner from "./Banner";

const Specialist = () => {


    return (
        <Fragment>
            <SpecialistSearchBanner />
            
        </Fragment>
    );
};

export default Specialist;